import React from "react";

import Button from "@replo/design-system/components/button/Button";
import twMerge from "@replo/design-system/utils/twMerge";
import { ArrowLeft } from "lucide-react";

export type PageHeaderProps = React.PropsWithChildren<{
  title?: string;
  titleComponent?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  onBackClick?: () => void;
  className?: string;
  divider?: boolean;
}>;

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  titleComponent,
  description,
  actions,
  children,
  onBackClick,
  className,
  divider = true,
}) => {
  return (
    <div
      className={twMerge(
        "w-full flex flex-col border-border gap-4 p-4 md:p-0",
        className,
        divider && "border-b-0.5 pb-2 md:pb-4",
      )}
    >
      <div className="flex flex-col space-y-1">
        <div className="flex justify-between items-start">
          {onBackClick && (
            <Button
              onClick={onBackClick}
              variant="tertiary"
              size="base"
              UNSAFE_className="font-normal"
              startEnhancer={<ArrowLeft size={12} />}
            >
              Back
            </Button>
          )}
        </div>
        <div className="flex justify-between items-start">
          <div className="flex items-start gap-1">
            <div className="flex flex-col">
              {title ? (
                <div className="header-h1 text-default break-words pl-2 md:pl-0">
                  {title}
                </div>
              ) : (
                <div className="pl-2 md:pl-0">{titleComponent}</div>
              )}
              {description && (
                <div className="text-sm text-muted break-words leading-relaxed pl-2 md:pl-0">
                  {description}
                </div>
              )}
            </div>
          </div>
          {actions && (
            <div className="flex space-x-3 items-center">{actions}</div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageHeader;
